<template>
  <Teleport to="body">
    <div v-show="modalActive" class="modal-bg" @click.self="$emit('close')">
      <div class="modal sub-bg" :class="size">
        <!-- :style="{ backgroundImage: `url(${require('@/assets/subcribe-bg.png')})` }" -->
        <div class="modal-header">
          <div style="display: flex; justify-content: center;">
            <img @contextmenu.prevent class="logo-img" :src="setCacheBuster('/TheMedia/company_logo-00871b8b-71e2-4473-9505-29018d779838.png')">
          </div>
          <i class="close-icon fa-solid fa-xmark" @click="$emit('close')"></i>
          <h2 style="text-align: center; color: white; margin-bottom: 10px; margin-top: 10px;">Đăng ký ngay</h2>
          <h4 style="text-align: center; color: white; margin-bottom: 20px;">
            Hãy đồng hành cùng chúng tôi và đăng ký để nhận được những thông tin mới nhất!</h4>
          <div>
            <form>
              <div class="row">
                <div class="col-70">
                  <input type="text" v-model="name" placeholder="Tên">
                </div>
              </div>

              <div class="row">
                <div class="col-70">
                  <input type="text" v-model="phoneNum" placeholder="Số điện thoại">
                </div>
              </div>

              <div class="row">
                <div class="col-70">
                  <input type="text" v-model="email" placeholder="Email">
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-30">
                  <label for="fname">Tên<span style="color: red;">*</span></label>
                </div>
                <div class="col-70">
                  <input type="text" v-model="name">
                </div>
              </div>

              <div class="row">
                <div class="col-30">
                  <label for="fname">Số điện thoại<span style="color: red;">*</span></label>
                </div>
                <div class="col-70">
                  <input type="text" v-model="phoneNum">
                </div>
              </div>

              <div class="row">
                <div class="col-30">
                  <label for="fname">Email<span style="color: red;">*</span></label>
                </div>
                <div class="col-70">
                  <input type="text" v-model="email">
                </div>
              </div> -->
            </form>
          </div>
        </div>

        <div class="modal-content">
          <!-- <button class="cancel" :disabled="requestLoading" @click="$emit('close')">Đóng</button> -->
          <button class="delete" :class="{ loading: requestLoading }" :disabled="requestLoading" @click="submitForm">
            <p class="btn-text">Đăng ký</p>
          </button>
        </div>
        <div class="g-recaptcha" style=" margin-bottom: 10px; justify-content: center; display: flex;" data-sitekey="6LdIQlwqAAAAAPyKKmSZUIBPiAYoLs18FbV_Fdk4"></div>
      </div>
    </div>
  </Teleport>
</template>
<script>
import axios from 'axios'

export default {
  props: {
    modalActive: {
      type: Boolean,
      require: false
    },
    size: {
      type: String,
      require: false,
      default: 'default'
    }
  },
  data () {
    return {
      requestLoading: false,
      name: null,
      phoneNum: null,
      email: null,
      propertiesToCheck: ['name', 'phoneNum', 'email'],
      isValid: false,
      msg: null,
      cacheBuster: Date.now()
    }
  },
  mounted () {
    // Dynamically load the Google reCAPTCHA script when the component is mounted
    const scriptId = 'recaptcha-script'
    // console.log('Google reCAPTCHA .')
    const script = document.createElement('script')
    script.src = 'https://www.google.com/recaptcha/api.js'
    script.async = true
    script.defer = true
    script.id = scriptId // To avoid duplicate script load
    document.head.appendChild(script)

    // Optionally: Listen for the script load to handle further logic
    script.onload = () => {
      console.log('Google reCAPTCHA script loaded.')

      // Initialize reCAPTCHA or execute any callback if needed
    }
    // if (!document.getElementById(scriptId)) {

    // }
  },
  methods: {
    setCacheBuster (url) {
      return `${url}?t=${this.cacheBuster}`
    },
    validateVariable () {
      this.isValid = true
      const hasNullValues = this.propertiesToCheck.some(key => this[key] === null || this[key] === '')
      if (hasNullValues) {
        this.isValid = false
        this.msg = 'Thiếu thông tin cần thiết'
        return
      }

      if (!this.email.includes('@')) {
        this.isValid = false
        this.msg = 'Sai định dạng email'
      }
    },
    async submitForm () {
      this.requestLoading = true

      const rs = window.grecaptcha.getResponse()
      if (!rs) {
        this.password = ''
        this.requestLoading = false
        this.$showError('Recaptcha Failure, Try Again')
        return
      }

      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError(this.msg)
        return
      }

      try {
        const subDetailData = {
          name: this.name,
          phoneNum: this.phoneNum,
          email: this.email.toLowerCase(),
          txtCaptcha: rs
        }

        await axios.post(this.$store.state.API_Url + 'SubscriptionDetails', subDetailData)

        this.name = null
        this.email = null
        this.phoneNum = null
        this.requestLoading = false
        this.$showSuccess('Đăng ký thành công')
        this.$emit('close')
      } catch (error) {
        this.requestLoading = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }

      this.requestLoading = false
    }
  },
  emits: ['close']
}
</script>
<style scoped>
.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.modal {
  background: #fff;
  width: 700px;
  align-self: center;
  border-radius: 12px;
  width: 450px;
}

.modal-header {
  position: relative;
  padding: 16px;
}

.modal-header h2 {
  margin-bottom: 10px;
}

.modal-header p {
  color: #ababab;
  font-size: 15px;
}

.modal-content {
  padding: 0 16px;
  padding-top: 0px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center
}

.modal-content button {
  position: relative;
  padding: 15px 25px;
  border-radius: 15px;
  outline: none;
  border: none;
  font-weight: bold;
  cursor: pointer;
  overflow: hidden;
}

.modal-content .delete {
  color: #fff;
  background: #F9BA10;
}

.modal-content .cancel {
  color: #969393;
  background: #efebeb;
}

.modal-content i {
  margin-right: 5px;
}

.btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .btn-text {
    font-size: 15px;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }

  input, select, textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    resize: vertical;
  }

  label {
    padding: 12px 12px 12px 0;
    display: inline-block;
  }

  .col-30 {
    float: left;
    width: 30%;
    margin-top: 6px;
  }

  .col-70 {
    float: left;
    width: 100%;
    margin-top: 12px;
  }

  .col-70 input {
    border-radius: 15px;
  }

  .row {
    margin: 10px 0px;
  }

  /* Clear floats after the columns */
  .row::after {
    content: "";
    display: table;
    clear: both;
  }

  .close-icon {
    color: white;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    transition: color 0.2s ease-in-out;
  }

  .close-icon:hover {
    color: red;
  }

  .sub-bg {
    background-color: #006884;
  }

  .logo-img {
    width: 370px;
    height: 65px;
    object-fit: contain;
  }
</style>
